import React from "react"
import {Table, Tbody, Td, Th, Thead, Tr} from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import {Badge} from "reactstrap"
import {Link} from "react-router-dom"
import ProgressView from "../ProgressView"

const formatAmount = (minor, currency) => {
    if (minor == null) return "—"
    const major = (minor / 100).toFixed(2)
    return `${currency || ""} ${major}`.trim()
}

const statusColor = (status) => {
    switch (status) {
        case "requested": return "warning"
        case "pending":   return "info"
        case "confirmed": return "success"
        case "failed":    return "danger"
        case "cancelled": return "secondary"
        default:          return "secondary"
    }
}

const truncate = (str, max = 40) => {
    if (!str) return "—"
    return str.length > max ? str.substring(0, max) + "…" : str
}

const formatDate = (isoString) => {
    if (!isoString) return "—"
    return new Date(isoString).toLocaleDateString()
}

const RefundsTable = ({rows = [], loading = false}) => {

    return <>

        {loading &&
        <div className={"p-2 text-center"}>
            <ProgressView/>
        </div>
        }

        {!loading && rows.length === 0 &&
        <div className={"p-2 text-center"}>
            <p className="mb-2 text-muted">No refunds found.</p>
        </div>
        }

        {!loading && rows.length > 0 &&
        <div className="table-rep-plugin">
            <div
                className="table-responsive mb-0"
                data-pattern="priority-columns"
            >
                <Table
                    className="table table-striped table-bordered"
                >
                    <Thead>
                        <Tr>
                            <Th>Business</Th>
                            <Th>Amount</Th>
                            <Th>Reason</Th>
                            <Th>Status</Th>
                            <Th>Created</Th>
                            <Th></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {rows.map((a, b) =>
                            <Tr key={b.toString()}>
                                <Th>
                                    <Link to={"/business/" + a.business_id}>
                                        {a.business_name || a.business_id}
                                    </Link>
                                </Th>
                                <Td>{formatAmount(a.amount_minor, a.currency)}</Td>
                                <Td>{truncate(a.reason)}</Td>
                                <Td>
                                    <Badge color={statusColor(a.status)}>
                                        {a.status}
                                    </Badge>
                                </Td>
                                <Td>{formatDate(a.created_at)}</Td>
                                <Td>
                                    <Link to={"/refunds/" + a.id}
                                          className="btn btn-primary btn-rounded waves-effect waves-light btn-sm">
                                        View
                                    </Link>
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            </div>
        </div>
        }
    </>

}

export default RefundsTable
